module.exports = __webpack_public_path__ + "img/checkmark-dark.bcf851a7.svg";